var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    var daysEnum = ['TXT_MONDAY', 'TXT_TUESDAY', 'TXT_WEDNESDAY', 'TXT_THURSDAY', 'TXT_FRIDAY', 'TXT_SATURDAY', 'TXT_SUNDAY'];

    // #region ScheduleDetail - Ctor
    ns.ScheduleDetail = function ScheduleDetail(scheduleWeeks) {
        this.scheduleWeeks = scheduleWeeks;
        this.days = [];
        for (var day = 1; day <= 7; day++) {
            this.days.push(new ns.ScheduleDetailDay(
                daysEnum[day - 1],
                scheduleWeeks,
                day, // isoWeekday
                this
                ));
        }
    }
    // #endregion   

    // #region ScheduleDetail - Methods
    ns.ScheduleDetail.prototype.getPrevFilledInDay = function (day) {
        var isoWeekday = day.dayOfWeek;

        // Find previous one
        for (var d = isoWeekday - 1; d >= 0; d--) {            
            var prev = this.days[d];

            if (prev.firstPeriodStartDate !== null ||
                prev.secondPeriodStartDate !== null) {
                return prev;
            }
        }

        // try nex one
        for (var d = isoWeekday + 1; d < this.days.length; d++) {
            var next = this.days[d];

            if (next.firstPeriodStartDate !== null ||
                next.secondPeriodStartDate !== null) {
                return next;
            }
        }

        return null;
    }

    ns.ScheduleDetail.prototype.onDataSourceChange = function () {
        for (var d = 0; d < this.days.length; d++) {
            this.days[d].onDataSourceChange.call(this.days[d]);
        }
    }

    ns.ScheduleDetail.prototype.applyChanges = function () {
        for (var d = 0; d < this.days.length; d++) {
            this.days[d].applyChanges.call(this.days[d]);
        }
    }
    // #endregion

    // #region ScheduleDetail - Properties
    Object.defineProperty(ns.ScheduleDetail.prototype, "active", {
        get: function () {
            var a = true;
            var cnt = 0;
            for (var i = 0; i < this.days.length; i++) {
                var d = this.days[i];
                a &= d.active;
                cnt++;
            }
            return a && cnt > 0;
        },
        set: function (value) {
            for (var i = 0; i < this.days.length; i++) {
                var d = this.days[i];
                d.active = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    // #endregion


}(webooker_acivity_models));